var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page-table-header"},[_c('PageHeader',{attrs:{"page-title":'Sales report'}})],1),_c('TableSalesReport')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }